const VIEW_FLIPPING_STATE = {
  FLIPPABLE_FROM_LEFT_ON_LEFT_SIDE: 'flippableFromLeftOnLeftSide',
  FLIPPABLE_FROM_LEFT_ON_LEFT_SIDE_FLIPPING_RIGHT: 'flippableFromLeftOnLeftSideFlippingRight',

  FLIPPABLE_FROM_LEFT_ON_RIGHT_SIDE: 'flippableFromLeftOnRightSide',
  FLIPPABLE_FROM_LEFT_ON_RIGHT_SIDE_FLIPPING_RIGHT: 'flippableFromLeftOnRightSideFlippingRight',

  READABLE_PAGE_LEFT: 'readablePageLeft',
  LEFT_PAGE_FLIPPING_TO_RIGHT: 'leftPageFlippingToRight',

  READABLE_PAGE_RIGHT: 'readablePageRight',
  RIGHT_PAGE_FLIPPING_TO_LEFT: 'rightPageFlippingToLeft',

  FLIPPABLE_FROM_RIGHT_ON_LEFT_SIDE: 'flippableFromRightOnLeftSide',
  FLIPPABLE_FROM_RIGHT_ON_LEFT_SIDE_FLIPPING_LEFT: 'flippableFromRightOnLeftSideFlippingLeft',

  FLIPPABLE_FROM_RIGHT_ON_RIGHT_SIDE: 'flippableFromRightOnRightSide',
  FLIPPABLE_FROM_RIGHT_ON_RIGHT_SIDE_FLIPPING_LEFT: 'flippableFromRightOnRightSideFlippingLeft',
};

export default VIEW_FLIPPING_STATE;
